import { render, staticRenderFns } from "./SecondaryNavBar.vue?vue&type=template&id=0364752d"
import script from "./SecondaryNavBar.vue?vue&type=script&lang=ts"
export * from "./SecondaryNavBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports